// import React from "react";
// import { Box, Typography, Card, CardContent } from "@mui/material";
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
// import { useLocation, useParams } from "react-router-dom";

// const NotificationPage = () => {
//       const location = useLocation();
//       if (location.pathname === "/approval/notification/T") {
//         window.history.pushState(null, document.title, "#");
//       }

//       const params = useParams()
//   return (
//     <Box
//       display="flex"
//       alignItems="center"
//       justifyContent="center"
//       minHeight="100vh"
//       bgcolor="#f0f4f8"
//     >
//       <Card sx={{ p: 4, textAlign: "center", borderRadius: 4, boxShadow: 3 }}>
//         <CardContent>
//           <CheckCircleIcon sx={{ fontSize: 80, color: "green" }} />
//           <Typography variant="h5" mt={2} fontWeight="bold">
//             Task  {params.status == "AP" ? "Approved" :"Rejected"}
//             </Typography>
//           {params.status == "AP" &&
//               <Typography variant="body1" mt={1} color="text.secondary">
//             Submitted task has been successfully reviewed and approved.
//             {/* It has been successfully reviewed and approved */}
//           </Typography>}
//         </CardContent>
//       </Card>
//     </Box>
//   );
// };

// export default NotificationPage;
import React from "react";
import { Box, Typography, Card, CardContent } from "@mui/material";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';
import { useParams } from "react-router-dom";
import InfoIcon from '@mui/icons-material/Info';

const NotificationPage = () => {
  const { type, status } = useParams();

  // Map type codes 
  const typeMap = {
    T: "Task",
    P: "Permission",
    OT: "Over Time",
    OD: "On Duty",
    L: "Leave",
    SA: "Salary Advance",
    EE: "Expense",
    RG: "Regularization"
  };

  const requestType = typeMap[type];

  // const isApproved = status === "AP";

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      minHeight="100vh"
      bgcolor="#f0f4f8"
    >
      <Card sx={{ p: 4, textAlign: "center", borderRadius: 4, boxShadow: 3 }}>
       
        <CardContent>
          {status === "AP" ? (
            <CheckCircleIcon sx={{ fontSize: 80, color: "green" }} />
          ) : status === "RJ" ? (
            <ErrorIcon sx={{ fontSize: 80, color: "red" }} />
          ) : (
            <InfoIcon sx={{ fontSize: 80, color: "orange" }} />
          )}

          <Typography variant="h5" mt={2} fontWeight="bold">
            {requestType}{" "}
            {status === "AP"
              ? "Approved"
              : status === "RJ"
                ? "Rejected"
                : "Queried"}
          </Typography>

          {status === "AP" && (
            <Typography variant="body1" mt={1} color="text.primary">
              Submitted {requestType} has been successfully reviewed and approved.
            </Typography>
          )}

          {status === "RJ" && (
            <Typography variant="body1" mt={1} color="text.primary">
              Submitted {requestType} has been reviewed and rejected.
            </Typography>
          )}

          {status === "QR" && (
            <Typography variant="body1" mt={1} color="text.primary">
              Submitted {requestType} has been reviewed and queried.
            </Typography>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default NotificationPage;

